var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-scrollbar__wrap wrap-white" }, [
    _c(
      "div",
      { staticClass: "el-scrollbar__view" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 0 } },
          _vm._l(_vm.dataList, function (item) {
            return _c(
              "el-col",
              { key: item.id, attrs: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 } },
              [
                _c(
                  "el-card",
                  {
                    staticClass: "jp-card jp-card-bordered",
                    staticStyle: { margin: "10px" },
                    attrs: {
                      "body-style": { padding: "0px" },
                      shadow: "always",
                    },
                  },
                  [
                    _c("div", {}, [
                      _c(
                        "div",
                        { staticClass: "jp-card-cover1" },
                        [
                          _c("i", {
                            class: item.icon,
                            staticStyle: {
                              "font-size": "64px",
                              color: "#409EFF",
                              "margin-right": "20px",
                            },
                          }),
                          _c(
                            "font",
                            { staticStyle: { "font-weight": "700" } },
                            [_vm._v(" " + _vm._s(item.name))]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "jp-card-body" }, [
                        _c("div", { staticClass: "jp-card-meta" }, [
                          _c("div", { staticClass: "jp-card-meta-detail" }, [
                            _c(
                              "div",
                              { staticClass: "jp-card-meta-description" },
                              [_vm._v(_vm._s(item.remarks))]
                            ),
                          ]),
                        ]),
                      ]),
                      _c("ul", { staticClass: "jp-card-actions" }, [
                        _c(
                          "li",
                          { staticStyle: { width: "100%" } },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: { content: item.tip, placement: "top" },
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: item.path,
                                      disabled: item.disabled,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-folder-open-o",
                                      style:
                                        "" +
                                        (item.disabled ? "color:grey" : ""),
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }